import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const NotFound = () => {
   useEffect(() => {
      document.title = "404: Not Found";
    }, []);

    const history = useHistory();

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} >
            <h1>404 - Not Found</h1>
            <p>The page you are looking for does not exist.</p>
            <Button className='mt-3' onClick={()=>{
               history.push("/")
            }} > Back to Home </Button>
        </div>
    );
};

export default NotFound;